export default __webpack_public_path__ + "static/media/Art.c98deae5.png";